import React, { useEffect, useState } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import SelectInput from "src/_common/components/form-elements/selectinput/selectInput";
import { useAppEventAction } from "src/_common/hooks/actions/event/appEventActionHook";
import { useEventApi } from "src/_common/hooks/actions/event/appEventApiHook";
import {
  useAppEvenListSelector,
  useAppEventGameListSelector,
  useAppEventLeaderBoardSelector,
} from "src/_common/hooks/selectors/eventSelector";
import { useAppGuestUserIdSelector, useAppUserDetailsSelector } from "src/_common/hooks/selectors/userSelector";
import { CRYPTO_SECRET_KEY, removeTrailingZero, URLS } from "src/_config";
import Sponsor from "src/components/common/Sponsor";
import moment from "moment";

const Cryptr = require("cryptr");
const cryptr = new Cryptr(CRYPTO_SECRET_KEY);

export default function RodeoEventLeaderBoardPage() {
  const eventApi = useEventApi();
  const leaderBoardSelector = useAppEventLeaderBoardSelector();
  const history = useHistory();
  const { eventId, performanceId, gameId } = useParams<any>();
  const e_id: number = parseInt(cryptr.decrypt(eventId));
  // const p_id: number = parseInt(cryptr.decrypt(performanceId));
  // const g_id: number = parseInt(cryptr.decrypt(gameId));
  const eventGameListSelector = useAppEventGameListSelector();
  const eventListSelector = useAppEvenListSelector();
  const guestUserId = useAppGuestUserIdSelector();
  const userDetails = useAppUserDetailsSelector();
  const [loginReq, setLoginReq] = useState<any>(0);
  const [leaderboardType, setLeaderboardType] = useState<any>(0);
  const [leaderboardList, setLeaderboardList] = useState<any>();
  // const [listOptions, setListOptions] = useState<any>([{ label: "Overall", value: "0" }]);
  const eventAction = useAppEventAction();
  const tiebreakerText = "RANDOM DRAW NUMBER (to be used for tie breaker): ";
  // const [leaderboardData, setLeaderboardData] = useState<any>([]);

  const goBack = (e: any) => {
    e && e.preventDefault();
    history.goBack();
  };

  const callViewLeaderBoard = (locId?: any) => {
    const params: any = {
      rodeo_event_id: e_id,
    };
    if (performanceId) {
      params["performance_id"] = parseInt(cryptr.decrypt(performanceId));
    }
    if (gameId) {
      params["rodeo_event_event_id"] = parseInt(cryptr.decrypt(gameId));
    }
    if (locId) {
      params["location_id"] = locId;
    }
    eventApi.callViewLeaderBoard(
      params,
      (message: string, resp: any) => {
        if (resp) {
          // setLeaderboardData(resp);
        }
      },
      (message: string) => {
        toast.error(message);
      }
    );
  };

  // const getLeaderboardLocationList = () => {
  //   let params: any = {
  //     type: "game",
  //     rodeo_event_id: e_id,
  //   };
  //   if (performanceId) {
  //     params["performance_id"] = parseInt(cryptr.decrypt(performanceId));
  //   }
  //   eventApi.callGetLeaderboardLocationList(
  //     params,
  //     (message: string, resp: any) => {
  //       //   console.log(resp?.locations?.length>0)
  //       if (resp?.locations?.length > 0) {
  //         let x: any = listOptions;
  //         resp?.locations?.map((loc: any) => {
  //           x.push({ label: loc.title, value: loc.location_id });
  //         });
  //         // console.log(x)
  //         setListOptions(x);
  //       }
  //     },
  //     (message: string) => {
  //       // toast.error(message)
  //     }
  //   );
  //   // }
  // };

  const handleListChange = (data: any) => {
    //   console.log({data})
    if (data?.value) {
      callViewLeaderBoard(data?.value);
    }
  };

  useEffect(() => {
    if (userDetails) {
      // getLeaderboardLocationList();
    }
  }, [userDetails]);

  useEffect(() => {
    callViewLeaderBoard();
  }, []);

  useEffect(() => {
    let x = leaderBoardSelector?.rodeo_event_game_info?.show_leaderboard;

    if (x) {
      setLeaderboardType(x);
      // if (x == 1) {
      //   setLeaderboardList(leaderBoardSelector?.players);
      // } else if (x == 2) {
      //   setLeaderboardList(leaderBoardSelector?.riders);
      // } else {
      //   setLeaderboardList(leaderBoardSelector?.events);
      // }
      setLeaderboardList(leaderBoardSelector?.answers);
    }
  }, [leaderBoardSelector]);

  return (
    <React.Fragment>
      <div className="main-content-panel">
        <div className="team-list-panel pt-3">
          <div className="d-flex justify-content-between align-items-center team-list-title-panel gap-3">
            <div className="team-list-title">
              <h1>{leaderBoardSelector?.performance_dtls?.title}</h1>
            </div>
            <div className="team-list-date">
              <p>
                {leaderBoardSelector?.performance_dtls?.pdate
                  ? moment(leaderBoardSelector?.performance_dtls?.pdate).format("MMM DD, YYYY")
                  : ""}
              </p>
            </div>
          </div>
          {gameId && (
            <div className="team-list-block">
              <div className="d-flex gap-3 align-items-center">
                {/* <div className="team-list-icon">
                <img
                  src={
                    leaderBoardSelector?.event_dtls?.avatar?.id != 0
                      ? leaderBoardSelector?.event_dtls?.avatar?.thumb
                      : "/images/no-image.png"
                  }
                  style={{ width: "100%" }}
                  alt={leaderBoardSelector?.event_dtls?.title}
                />
              </div> */}
                <div className="team-list-content flex-grow-1 justify-content-center">
                  <h4 className="mb-1 text-white">{leaderBoardSelector?.event_dtls?.event_title}</h4>
                </div>
              </div>
            </div>
          )}
          <h3 className="section-heading mb-3">Leaderboard</h3>
          {/* <p className="mb-4 text-blue-cstm">
            RANDOM DRAW NUMBER (to be used for tie breaker): <strong>5817</strong>
          </p> */}
          <div className="leaderboard-score score-range-wrap">
            <div className="score-box d-flex justify-content-between">
              <h4 className="d-inline-block title-player">Users</h4>
              {/* <div className="gua-sc">Tie Breaker Code</div> */}
              <div className="gua-sc">Result</div>
            </div>
            <ul className="cons-list">
              {leaderboardList?.length ? (
                leaderboardList?.map((item: any) => (
                  <li key={item.id}>
                    <span className="name-img leaderboard-name-img flex-fill">
                      {item?.user_details?.display_name || item?.user_details?.full_name}
                    </span>
                    {/* <span className="count-vote p-0 flex-fill" style={{ textAlign: "center" }}>
                  14143
                </span> */}
                    <span className="count-vote flex-fill">{item?.total_point || 0}</span>
                  </li>
                ))
              ) : (
                <li className="no-rider">No record found!</li>
              )}
            </ul>
          </div>
        </div>
      </div>
      <Sponsor />
    </React.Fragment>
  );
}
